import i18n from '../i18n';

/**
 * Formats a money amount using the active UI locale's grouping/decimal
 * conventions and appends the currency code, e.g. "3 000,00 PLN".
 * Locale-driven so RU and PL students read amounts naturally
 * ("3 000,00" vs "3,000.00"). Currency is a plain code suffix (PLN, EUR)
 * — not an Intl currency style — because the backend sends free-form codes.
 */
export const formatMoney = (amount: number, currency: string): string => {
  const locale = i18n.language === 'pl' ? 'pl-PL' : 'ru-RU';
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  return `${formatted} ${currency}`.trim();
};
